import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import AccountService from '@/services/AccountService';
import { validationMixin, useSpinValidate } from '@/plugins/vuelidateCompat';
import { required, email, minLength } from '@vuelidate/validators';
import AddressForm from '@/components/forms/Address';
const cellPhone = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  } else {
    return /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value);
  }
};
export default {
  components: {
    AddressForm
  },
  data: () => {
    return {
      loading: false,
      editUsername: false,
      editPassword: false,
      editInfo: false,
      searchZip: false,
      searchUsername: false,
      searchEmail: false,
      usernameTaken: false,
      emailTaken: false,
      account: {
        user: {
          username: null,
          password: null,
          password2: null,
          firstname: null,
          lastname: null,
          email: null,
          countrycode_id: null,
          phone: null,
          promo: true
        },
        address: {
          address1: null,
          address2: null,
          zip: null,
          city: null,
          state: null,
          country_id: null
        }
      },
      states: [],
      countries: [],
      startingAdddress: null,
      validAddress: false
    };
  },
  created: function () {
    this.init();
  },
  methods: {
    init: function () {
      this.loading = true;
      AccountService.init().then(response => {
        if (response && response.data && response.data.user) {
          this.account.user = response.data.user;
          this.startingAdddress = response.data.address;
          this.states = response.data.states;
          this.countries = response.data.countries;
        } else {
          alert('Failed to load account info! ' + response.data.error[0]);
        }
      }).catch(error => {
        alert('Failed to load account info! ' + error.data.error[0]);
      }).finally(() => {
        this.loading = false;
        this.editUsername = false;
        this.editPassword = false;
        this.editInfo = false;
        // $autoDirty (set in vuelidateCompat) flips $dirty on any model change,
        // including the API-driven assignment above. Clear it so the Save
        // button only re-enables once the user actually edits a field.
        this.$nextTick(() => this.$v.$reset());
      });
    },
    save: function () {
      if (this.loading || !this.validAddress || this.$v.account.$anyError) {
        return;
      }
      this.loading = true;
      AccountService.save(this.account).then(response => {
        if (response && response.data && !response.data.error) {
          this.$v.$reset();
          this.init();
        } else {
          alert('Failed to save account info! ' + response.data.error[0]);
        }
      }, error => {
        console.dir(error);
        alert('Failed to save account info! ' + error.data.error[0]);
      }).finally(() => {
        this.loading = false;
      });
    },
    getErrors: function (form, field, validators) {
      const err = [];
      if (!this.$v.account[form][field].$dirty) return err;
      validators.forEach(e => {
        if (this.$v.account[form][field][e].$invalid) {
          e === 'required' && err.push('This field is required');
          e === 'sameAsPassword' && err.push('Passwords do not match');
          e === 'minLength' && err.push(field.capitalize() + ' must be at least ' + this.$v.account[form][field].minLength.$params.min + ' characters');
          e === 'email' && err.push('Please enter a valid email');
          e === 'cellPhone' && err.push('Please enter a valid phone number');
        }
      });
      return err;
    },
    checkUsername: function () {
      if (this.loading || this.$v.account.user.username.$invalid) {
        this.usernameTaken = false;
        return;
      }
      this.searchUsername = true;
      AccountService.checkUsername(this.account.user.username).then(response => {
        this.usernameTaken = !response.data.exists;
      }, error => {
        console.log(error);
        alert('Failed to look up username!');
      }).finally(() => {
        this.searchUsername = false;
      });
    },
    checkEmail: function () {
      if (this.loading || this.$v.account.user.email.$invalid) {
        this.emailTaken = false;
        return;
      }
      this.searchEmail = true;
      AccountService.checkEmail(this.account.user.email).then(response => {
        this.emailTaken = !response.data.result;
      }, error => {
        console.log(error);
        alert('Failed to look up username!');
      }).finally(() => {
        this.searchEmail = false;
      });
    },
    setValidAdress: function (valid) {
      this.validAddress = valid;
    },
    setAdress: function (address) {
      this.account.address = address;
    }
  },
  computed: {
    countryCodes: function () {
      const codes = [];
      this.countries.forEach(e => {
        codes.push({
          id: e.id,
          text: e.isothreeletter + ' - +' + e.countrycode
        });
      });
      return codes;
    }
  },
  mixins: [validationMixin],
  setup() {
    return useSpinValidate();
  },
  validations: {
    account: {
      user: {
        username: {
          required,
          minLength: minLength(5)
        },
        password: {
          required,
          minLength: minLength(6)
        },
        password2: {
          required,
          // Vuelidate 2 sameAs() compares to a value, not a field name
          sameAsPassword: (value, siblings) => value === siblings.password
        },
        firstname: {
          required
        },
        lastname: {
          required
        },
        email: {
          required,
          email
        },
        phone: {
          required,
          minLength: minLength(10),
          cellPhone
        },
        countrycode_id: {
          required
        },
        // No real rule — declared only so $autoDirty tracks the promo checkbox
        // and toggling it flips $anyDirty, which the Save button is gated on.
        promo: {
          tracked: () => true
        }
      },
      address: {
        address1: {
          required
        },
        zip: {
          required,
          minLength: minLength(5)
        },
        city: {
          required
        },
        state: {
          required
        },
        country_id: {
          required
        }
      }
    }
  }
};